import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router'
import { UserRoleEnum } from '../models/interfaces/user.interface'
import { AuthenticationService } from './authentication.service'

export const CanActivateIsAdmin: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
   const authService = inject(AuthenticationService)
   const router = inject(Router)
   return authService.retriveRole().then((role) => (role === UserRoleEnum.ADMIN ? true : router.createUrlTree(['/'])))
}

export const CanActivateIsBase: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
   const authService = inject(AuthenticationService)
   const router = inject(Router)
   return authService.retriveRole().then((role) => (role === UserRoleEnum.BASE ? true : router.createUrlTree(['/'])))
}

export const CanActivateNoRoles: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
   const authService = inject(AuthenticationService)
   const router = inject(Router)
   return authService.retriveRole().then((role) => (role === undefined ? true : router.createUrlTree(['/'])))
}
